import React from 'react';
const HowItWorks = () => {
  const steps = [{
    number: '01',
    title: 'Schedule a Free Demo',
    description: 'Book a personalized demo session for your team to experience our premium beverage options and see how our system fits into your restaurant space.'
  }, {
    number: '02',
    title: 'Customize Your Solution',
    description: "We'll work with you to design a beverage program that fits your space, budget, and menu preferences with a simple water line and CO₂ hookup installation."
  }, {
    number: '03',
    title: 'Enjoy & Monitor',
    description: 'Our team handles installation, training, and setup. Access your dashboard to track usage, costs, and environmental impact with 24/7 support.'
  }];
  return <section className="py-20 bg-white" data-id="element-864">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-865">
        <div className="text-center mb-16" data-id="element-866">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-867">
            How SmartSoda Works
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-868">
            A simple process to transform your restaurant's beverage experience
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-869">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-870">
              <div className="absolute -left-4 -top-4 w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-871">
                <span className="text-xl font-bold text-blue-600" data-id="element-872">
                  {step.number}
                </span>
              </div>
              <div className="bg-white pt-16 pb-8 px-6 rounded-xl border border-gray-100 shadow-sm h-full" data-id="element-873">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-874">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-875">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-6 transform -translate-y-1/2" data-id="element-876">
                  <svg width="40" height="12" viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-877">
                    <path d="M39.5303 6.53033C39.8232 6.23744 39.8232 5.76256 39.5303 5.46967L34.7574 0.696699C34.4645 0.403806 33.9896 0.403806 33.6967 0.696699C33.4038 0.989593 33.4038 1.46447 33.6967 1.75736L37.9393 6L33.6967 10.2426C33.4038 10.5355 33.4038 11.0104 33.6967 11.3033C33.9896 11.5962 34.4645 11.5962 34.7574 11.3033L39.5303 6.53033ZM0 6.75H39V5.25H0V6.75Z" fill="#D1D5DB" data-id="element-878" />
                  </svg>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-879">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-880">
            Get Your Custom Quote
          </a>
        </div>
      </div>
    </section>;
};
export default HowItWorks;